import { render } from "./AddPage.vue?vue&type=template&id=2b2525e1&scoped=true&ts=true"
import script from "./AddPage.vue?vue&type=script&lang=ts"
export * from "./AddPage.vue?vue&type=script&lang=ts"

import "./AddPage.vue?vue&type=style&index=0&id=2b2525e1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Documents\\Personal\\Projects\\Slideshow\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2525e1"]])

export default __exports__